/* Click-to-load video inside the featured brand banner.
   Nothing from YouTube or Vimeo is requested until the visitor presses the play button.
   A close button puts the picture and text back. */
(function () {
  if (window.frbFeaturedBrandVideo) return;
  window.frbFeaturedBrandVideo = true;

  function stop(feature, media, playButton) {
    var iframe = media.querySelector('iframe');
    var close = media.querySelector('.frb-feature__close');
    if (iframe) iframe.remove();
    if (close) close.remove();
    feature.classList.remove('is-playing');
    if (playButton) playButton.focus();
  }

  document.addEventListener('click', function (event) {
    var play = event.target.closest('.frb-feature__play');
    if (!play) return;
    var media = play.closest('[data-frb-video]');
    var feature = play.closest('.frb-feature');
    if (!media || !feature) return;

    var iframe = document.createElement('iframe');
    iframe.src = media.getAttribute('data-frb-video');
    iframe.title = media.getAttribute('data-frb-video-title') || '';
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    iframe.allowFullscreen = true;
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'frb-feature__close';
    close.setAttribute('aria-label', media.getAttribute('data-frb-close-label') || 'Close');
    close.textContent = '×';
    close.addEventListener('click', function () { stop(feature, media, play); });

    feature.classList.add('is-playing');
    media.appendChild(iframe);
    media.appendChild(close);
    close.focus();
  });
})();
